import { Helmet } from "react-helmet";

const ServiceSchema = ({
  serviceType,
  url,
  description,
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceType,
    "name": serviceType,
    "description": description,
    "provider": {
      "@type": "TravelAgency",
      "name": "Amruta Travels",
      "url": "https://bushireinpune.com"
    },
    "areaServed": {
      "@type": "City",
      "name": "Pune"
    },
    "url": url
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ServiceSchema;